/**
 * <h1> 个人资料-基本信息-描述列表的字段映射</h1>
 * @author yang5chao@aliyun.com
 * @create 2020-9-28 09:55
 */
export const modalFreezeTitle = '您将要冻结该用户，确认继续操作么'
export const modalCancelFreezeTitle = '您将要解冻该用户，确认继续操作么'

export const userFieldMap = {
  nickname: '昵称',
  age: '年龄',
  mobile: '联系方式',
  wechatId: '微信号',
  inviter: '上级昵称',
  lastLoginTerminal: '最近登陆终端',
  lastLoginTime: '最近登陆时间',
  regTime: '注册时间',
  inviteCode: '邀请码'
}

// 0未认证、1已认证、2认证中、空：全部
export const authStatusEnum = [
  { value: 0, tag: 'danger', label: '认证拒绝' },
  { value: 1, tag: 'success', label: '认证通过' },
  { value: 2, tag: ' ', label: '认证中' },
  { value: ' ', tag: ' ', label: '全部' }
]
// 0不在线、1在线
export const onlineStatusEnum = [
  { value: 0, tag: 'danger', label: '不在线' },
  { value: 1, tag: 'success', label: '在线' }
]
// 0 否、1是
export const simulationStatusEnum = [
  { value: 0, tag: 'danger', label: '否' },
  { value: 1, tag: 'success', label: '是' }
]

// 1已认证、2认证中、空：全部
export const authSex = [
  { value: 1, tag: '', label: '男' },
  { value: 2, tag: ' ', label: '女' },
]

export const authTypeEnum = [
  { label: '初级认证', value: 1 },
  { label: '高级认证', value: 2 },
  { label: '全部', value: ' ' }
]

export const payTypeEnum = {
  1: 'AA',
  2: '我请',
  3: '找人请'
}

